/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/*
app.controller('calendarCtrl', ['$rootScope', '$scope', '$http', 'ColorService', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, ColorService, NetworkService, MainService, Notification) {
        $scope.people = [];
        $scope.eventId = EventId;
        $scope.hourHeight = 35;
        $scope.email = UserId
        $scope.calendarDataHere = false
        $scope.paginatorPage = 0

        NetworkService.getMitarbeiterDetails(UserId, function (data) {
            $rootScope.$emit("setNavName", data);
        })

        MainService.setEventData({event_id: EventId})
        MainService.setEmail($scope.email)

        function startTour() {
            var firstCol = $(".calendarCol ")[0]
            var firstPosition = $(firstCol).find(".schicht")[0]
            $(firstCol).attr("data-step", 2)
            $(firstCol).attr("data-intro", "Das ist eine Position")

            $(firstPosition).attr("data-step", 3)
            $(firstPosition).attr("data-intro", "Das ist eine Position in einer speziellen Schicht <br><br> Hier kannst du dich Eintragen")
            var tour = introJs()
            tour.setOption('tooltipPosition', 'auto');
            tour.setOption('positionPrecedence', ['left', 'right', 'bottom', 'top'])
            tour.start()
        }


        NetworkService.getHighestPermission(function (data) {
            $scope.secLevel = data.level
        })


        NetworkService.getLoggedInCount($scope.email, function (data) {
            var count = data.count;
            if (count < 1)
            {
                setTimeout(function () {
                    startTour()
                }, 1700)

            }
            NetworkService.raiseLoggedInCounter($scope.email, function () {

            })
        })


        $scope.dropDownPositionen = [
            {
                name: "Müllmann",
                id: 1
            },
            {
                name: "Security",
                id: 2
            },
            {
                name: "Radstand",
                id: 3
            }
        ]


        $scope.success = function (msg) {
            Notification.success(msg);
        };
        $scope.data = {}

        actualPos = -1
        actualTime = -1

        $scope.startDate = -1
        $scope.schichtId = -1;
        $scope.posId = -1;
        $scope.CalenderAgent = -1
        $scope.maId = UserId
        $scope.eventDetailsLoaded = false;
        NetworkService.getEventDetails($scope.eventId, function (data) {
            $scope.event = data;
            $scope.eventDetailsLoaded = true;
        })

        NetworkService.getAllSpecialFields(function (data) {
            $scope.specialFields = data.fields
        })

        $scope.getPartner = function (schichtObj)
        {
            var partnername = schichtObj.partner;
            if (partnername == null)
            {
                partnername = schichtObj.gesucht;
            }
            return partnername;
        }
        $scope.hasPartner = function (posObj, schichtObj)
        {

            if (schichtObj.partner != null || schichtObj.gesucht != null)
            {

                return true;
            }

            return false;
        }

        $scope.getFreePositionsInSchicht = function (schichtObj)
        {
            return schichtObj.menge - schichtObj.mitarbeiter
        }

        $scope.generateFullStatus = function (schichtObj)
        {
            var free = $scope.getFreePositionsInSchicht(schichtObj)
            var all = schichtObj.menge
            //return "<span class=''>" + free + "</span> von Plätzen " + all + " frei"
            if(free == 1)
            {
              return "<span class=''>" + free + "</span> Platz frei"
            }
            else {
              return "<span class=''>" + free + "</span> Plätze frei"
            }

        }
        $scope.ifOverlaps = function (el)
        {
            var ret = false
            if (el.email == null)
            {
                lapsOver = $scope.CalenderAgent.doesOverlapp(el)
                if (lapsOver)
                {
                    if (el.mitarbeiter[$scope.email] == undefined)
                    {
                        ret = true
                    }

                } else
                {
                }
            }
            return ret
        }

        $scope.openEventManager = function ()
        {
            window.location.replace("./Event.php?eventid=" + $scope.eventId);
        }

        $scope.getEventImage = function ()
        {
            var str = "imgs/eventImgs/event_" + $scope.eventId + ".png"
            return str;
        }
        $scope.startMover = function (pos, posObj, schicht)
        {
            ret = 0


            start = posObj.start
            var t = start.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            //hours = d / 1000 / 60 / 60;


            var t2 = $scope.startDate.split(/[- :]/);
            var d2 = new Date(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]);
            posi = d - d2
            posi = posi / 1000 / 60 / 60

            actualPos = pos
            posi *= $scope.hourHeight
            return posi
        }

        $scope.timeouts = []
        $scope.showMaximize = true;
        $scope.maximizeShift = function ($event)
        {
            console.log($event)
            var el = $($event.currentTarget).parent().parent();
            $scope.showMaximize = false;
            $(el).css("height", "auto");
            //$scope.timeouts.push(timeout)

        }

        $scope.showPositionDescription = function (data)
        {

            MainService.setDialogData("dialog_moveUserCtrl", data)
            $rootScope.$emit("updateDialogView")
            $("#dialog_positionDescription").modal("open")()
        }

        $scope.isShiftEmpty = function (schicht)
        {
            var ret = false
            if (schicht.menge == 0 || schicht.menge == null)
            {
                ret = true;
            }
            return ret;
        }
        $scope.minimizeShift = function ($event)
        {
            $scope.showMaximize = true;
            var el = $($event.currentTarget).parent().parent();
            $(el).css("height", "130px");
        }

 
        $scope.paintCalendar = function (position_id)
        {
            NetworkService.getCalendarForShiftManager(EventId, function (data) {
                $scope.calendarDataHere = true;
                $scope.renderCalendar(data, position_id)
            })
        }

        $scope.getIfIsFromAdmin = function(schichtObj)
        {
          return schichtObj.approved == 2 && schichtObj.email != null
        }

        $scope.openRegisterForSchichtDialog = function ()
        {

        }
        $scope.getAcceptControlls = function (data, i)
        {
            var ret = true;
            //var mitarbeiter = data["mitarbeiter"][i];

            if (data.email != null)
            {
                console.log("---###---##---")
                console.log(data.approved)
                if (data.approved == 2)
                {
                    console.log("#####")
                    console.log(data.approved)
                }

                if (data.approved == 2 && i == 0)
                {
                    ret = false
                }
            }

            return ret;
        }


        $scope.getIfUsed = function (data, i)
        {

            var ret = false;
            var besetzt = data["mitarbeiter"]
            var menge = data["menge"]
            if (data.email == $scope.email)
            {
                menge++;
            }
            if (i >= (menge - besetzt))
            {
                ret = true;
            }

            if (i == 0)
            {
                if (data.email == $scope.email)
                {
                    ret = true;
                }
            }
            return ret;
        }



        $scope.getIsUsedText = function (data, i)
        {
            var ret = "-1";
            var besetzt = data["mitarbeiter"]

            var menge = data["menge"]


            //if (i < (menge - besetzt))
            if (data.email == $scope.email)
            {
                menge++;
            }
            if (i < (menge - besetzt))
            {
                ret = "RESERVIERT"

            } else
            {
                ret = "BESETZT"

            }


            return ret;
        }

     
        $scope.isUsedByMe = function (data, i)
        {
            var ret = false;

            if (i == 0)
            {
                if (data.email == $scope.email)
                {
                    ret = true;
                }
            }

            return ret;
        }

        $scope.isPartnerField = function (data, email)
        {
            var ret = true;
            if (data.partner == null)
            {
                ret = false;
            }
            return ret;
        }

        $scope.getMyPartner = function (data)
        {
            var ret = "-1";
            ret = data["partner_vorname"] + " " + data["partner_nachname"]
            if (data["partner_status"] == 1)
            {
                ret += " zugesagt"
            } else
            {
                ret = "Bestätigung ausstehend"
            }
            return ret;
        }

        $scope.generateFreiText = function (schichtObj)
        {

            var ret = "Frei"
            if (schichtObj.menge == "-1")
            {
                ret = "unbegrenzt"
            }

            return ret;
        }


        $scope.checkIfFull = function (data)
        {
            ret = "";
            mitarbeiter_count = Object.keys(data.mitarbeiter).length;
            if (data.mitarbeiter[$scope.email] == undefined)
            {
                if (mitarbeiter_count == data.menge)
                {
                    ret = ""//"Voll"
                }
            }

            return ret;
        }
        $scope.generateApprovedText = function (data)
        {
            text = ""

            if (data.email == $scope.email)
            {
                if (data.approved == 1)
                {
                    text = ""//"Sie sind Eingetragen"
                } else if (data.approved == 0)
                {
                    text = "Muss noch vom Admin freigegeben werden"
                }
            }
            return text
        }

        $scope.acceptAdminSchicht = function (schichtObj, posObj)
        {
            
            MainService.setDialogData("dialog_acceptUserSchichtCtrl", {posObj: posObj, schichtObj: schichtObj})
            $rootScope.$emit("render_registerForSchichtCtrl")
            $("#dialog_registerForAdminSchicht").modal()
            $("#dialog_registerForAdminSchicht").modal("open")
        }

        $scope.declineAdminSchicht = function (schichtObj, posObj)
        {
            NetworkService.declineAdminSchicht($scope.email, schichtObj.schicht_id, posObj.position_id, function () {
                $scope.paintCalendar()
            })
        }

        $rootScope.$on("repaint", function () {
            $scope.paintCalendar()
        });
        $rootScope.$on("registerForSchicht", function () {
            //$scope.registerForSchichtButton()
        });


        $scope.checkIfOverlap = function (el)
        {
            ret = ""
            if (el.email == undefined)
            {
                lapsOver = $scope.CalenderAgent.doesOverlapp(el)
                if (lapsOver)
                {
                    ret = "Gleichzeitig mit meiner Schicht"

                } else
                {
                    ret = ""
                }
            }
            return ret

        }

        $scope.overLapCss = function (el)
        {
            ret = ""
            if (el.email == undefined)
            {
                lapsOver = $scope.CalenderAgent.doesOverlapp(el)
                if (lapsOver)
                {
                    ret = "background-color: #95a5a6;cursor:default;"

                } else
                {
                }
            }
            return ret

        }

        $scope.hideOverlay = function ()
        {
            $("#registerForSchichtWindow").fadeOut();
            $("#overlayWindow").fadeOut();
        }

        $scope.renderDate = function (d)
        {
            try
            {
                var myDate = new mDate(d)
                return myDate.getDate();
            } catch (Exception)
            {
            }
        }

        $scope.renderTime = function (d)
        {
            try
            {
                var myDate = new mDate(d)
                return myDate.getTime();
            } catch (Exception)
            {
            }
        }

        $scope.renderClass = function (data)
        {
            ret = "black"
            userWorking = data["mitarbeiter"][$scope.maId];
            lapsOver = $scope.CalenderAgent.doesOverlapp(data);
            // Wenn er Mitarbeitet
            if (data.menge == null)
            {
                ret = "white noschicht"
            } else if (userWorking != undefined)
            {
                ret = "works yellow lighten-4"
            } else if (lapsOver)
            {
                ret = "lapsOver blue-grey lighten-3"
            } else if (data.menge == data.mitarbeiter.length)
            {
                ret = "blue"
            } else // Wenn noch plaetze frei sind
            {
                ret = "open light-green accent-3"
            }
            return ret
        }

       
        $scope.getSize = function (von, bis)
        {

            var t = von.split(/[- :]/);
            var d1 = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            var t2 = bis.split(/[- :]/);
            var d2 = new Date(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]);
            var timeDiff = Math.abs(d2 - d1);
            difHours = timeDiff / 1000 / 60 / 60
            //return d.getHours()+":"+d.getMinutes()
            size = difHours * $scope.hourHeight
            if (size < 52)
            {
                size = 59;
            }
            return size;
        }

        $scope.isGuest = function ()
        {
            var ret = false;
            if ($scope.email == "gastaccount.atlas@hosiwien.at")
            {
                ret = true;
            }

            return ret;
        }


        $scope.openIndex = function ()
        {
            window.location.replace('index.php');
        }
        $scope.registerForSchicht = function (posObj, schichtObj)
        {

            if ($scope.isGuest())
            {
                Notification.primary({positionY: "bottom", message: "Registriere dich bzw. Log dich ein um dich für Schichten melden zu können.", templateUrl: "custom_template.html", scope: $scope});

            } else
            {
                if (lapsOver = $scope.CalenderAgent.doesOverlapp(schichtObj))
                {
                    if (schichtObj.email != null)
                    {
                        console.log("START EDITING")
                    }
                } else
                {
                    if (schichtObj.email != null)
                    {
                        console.log("START EDITING")
                    } else
                    {
var mit = parseInt(schichtObj.mitarbeiter);
var me = parseInt(schichtObj.menge);
                      if(mit<me)
                      {
                        $scope.schichtId = schichtObj.schicht_id;
                        $scope.posId = posObj.position_id;
                        var data = {schichtObj: schichtObj,
                            posObj: posObj,
                            email: $scope.email}
                        MainService.setDialogData("dialog_acceptUserSchichtCtrl", data)
                        $rootScope.$emit("render_registerForSchichtCtrl")
                    
                        $("#dialog_registerForSchicht").modal("open");
                      }
                      else {
                        alert("Position bereits voll")
                      }
                    }
                }
            }


        }
        $scope.calendarWidth = 3
        $scope.preRenderedCalendar = []


        $scope.preRenderCalendarData = function (data)
        {
          if(window.mobilecheck())
          {
            $scope.calendarWidth = 1
          }
            var size = $scope.calendarWidth;
            var newCalendar = []
            var subCalendar = []
            var ind = 0
            if (data != undefined)
            {
                Object.keys(data).forEach(function (el) {

                  
                    if (ind % size == 0 && ind != 0)
                    {
                        newCalendar.push(subCalendar)
                        subCalendar = []
                    }
                    subCalendar.push(data[el])
                    ind++;
                })
            }
            newCalendar.push(subCalendar)
            //console.log(newCalendar)
            $scope.preRenderedCalendar = newCalendar;
        }
        $scope.filterCalendarPage = function (data, start)
        {
            console.log($scope.preRenderedCalendar)
            return $scope.preRenderedCalendar[start]
        }
        $scope.getIfActiveTabClass = function (i)
        {
            ret = "";
            if (i == 0)
            {
                ret = "active"
            }
            return ret;
        }
        var myPage = 0;
        $scope.leftNextPage = function ()
        {
            if ($scope.paginatorPage > 0)
            {
                $scope.paginatorPage--;
                $scope.loadCalendarPage($scope.paginatorPage)
            }

        }

        $scope.rightNextPage = function ()
        {
            $scope.paginatorPage++;
            $scope.loadCalendarPage($scope.paginatorPage)
        }
        $scope.loadCalendarPage = function (page)
        {
            $(".topTabs").removeClass("active")
            $("#paginatorId" + page).toggleClass("active")
            //page = page * $scope.calendarWidth
            filteredData = $scope.filterCalendarPage($scope.wholeCalendar, page)
            $scope.positionen = filteredData
        }



        $scope.getPaginator = function (calendar)
        {
            var item = calendar
            var ret = []
            var lastThree = ""
            var ind = 1;
            var buttonId = 0
            var keys = Object.keys(item)
            var keyind = 9 * $scope.paginatorPage
            var lastButtonNotRenderd = false;
            if (item != undefined)
            {
                while (keyind < (keys.length) && buttonId < 3)
                {
                    var el = keys[keyind];
                    if (ind % 3 == 0)
                    {
                        lastThree += item[el].position_description + ""
                        ret.push({name: lastThree, id: buttonId + ($scope.paginatorPage * 3)})
                        lastThree = ""
                        lastButtonNotRenderd = false
                        buttonId++;
                    } else
                    {
                        lastThree += item[el].position_description + " | "
                        lastButtonNotRenderd = true
                    }

                    ind++;
                    keyind++;
                }

            }
            if (lastButtonNotRenderd)
            {
                ret.push({name: lastThree, id: buttonId + ($scope.paginatorPage * 3)})
            }

            return ret;
        }

        $scope.rightNextPaginator = function ()
        {
            var length = Object.keys($scope.wholeCalendar).length
            if (length > (($scope.paginatorPage + 1) * 9))
            {
                $scope.paginatorPage++;
                $scope.paginator = $scope.getPaginator($scope.wholeCalendar);
            }
        }

        $scope.leftNextPaginator = function ()
        {
            if ($scope.paginatorPage > 0)
            {
                $scope.paginatorPage--;
                $scope.paginator = $scope.getPaginator($scope.wholeCalendar);
            }

        }

        $scope.lastMobilePage = undefined

        $scope.checkIfImInShift = function (schichtObj)
        {
            return schichtObj.email != null;
        }
        $scope.getShiftCss = function (schichtObj, posObj)
        {
            el = schichtObj
            var ret = ""
            //console.log(posObj)

            if (!$scope.checkIfImInShift(schichtObj))
            {
                lapsOver = $scope.CalenderAgent.doesOverlapp(el)
                if (lapsOver)
                {
                    if (el.mitarbeiter[$scope.email] == undefined)
                    {
                        ret = "lappsOver"
                    }

                } else
                {
                    if($scope.getFreePositionsInSchicht(schichtObj) == 0)
                    {
                        ret = "fullShift"
                    }
                }
            } else
            {
                ret += "myShift"
            }
            return ret
        }
        $scope.openMobilePage = function (position_id)
        {
            $scope.calendarWidth = 1;
            $scope.paintCalendar(position_id)
        }

        $scope.firstRender = true;

        $scope.renderCalendar = function (data, mobilePos)
        {
            $scope.wholeCalendar = data["positionen"]
            $scope.preRenderCalendarData($scope.wholeCalendar)
            $scope.paginator = $scope.getPaginator(data["positionen"]);

            var key = Object.keys(data["positionen"])[0]
            $scope.positionsForDropdown = data["positionen"];
            $scope.stopRender = true;
            $scope.mobilePage = data["positionen"][key]//data["positionen"][key]
            $scope.stopRender = false;
            console.log("####----------")

            console.log("--")
            if(window.mobilecheck())
            {
                mobilePos = Object.keys(data["positionen"])[0]
            }
          //  mobilePos = window.mobilecheck()

            setTimeout(function () {
                $("#positionSelect").material_select();
            }, 500)

            if (mobilePos != undefined)
            {
                var a = $scope.wholeCalendar[mobilePos]
                $scope.positionen = {}
                $scope.positionen[mobilePos] = a
            } else
            {
                var filteredData = $scope.filterCalendarPage($scope.wholeCalendar, 0)
                $scope.positionen = filteredData
            }
            console.log("#+#+")
            console.log(data)
            $scope.CalenderAgent = new calenderChecker(data["positionen"], $scope.maId);
            len = $scope.calendarWidth//Object.keys(data.data["positionen"]).length
            ratio = 100 / len
            //console.log(data.data["positionen"])
            Object.keys(data["positionen"]).forEach(function (el) {
                //console.log(data.data["position"][el]["schichten"][0])

                firstKey = Object.keys(date = data["positionen"][el]["schichten"])[0]
                date = data["positionen"][el]["schichten"][firstKey]["start"]

                if ($scope.startDate == -1)
                {
                    $scope.startDate = date;
                }

                if ($scope.startDate > date)
                {
                    $scope.startDate = date;
                }
            })

            $("head").append('<style type="text/css"></style>');
            var newStyleElement = $("head").children(':last');
            //console.log(ratio)
            newStyleElement.html('.head{width:' + ratio + '%;}');
            $("head").append('<style type="text/css"></style>');
            var newStyleElement = $("head").children(':last');
            newStyleElement.html('.calendarCol{width:' + ratio + '%;}');
            //(".head").css("width", ratio + "%")

            $scope.firstRender = false;
        }

       $scope.paintCalendar()




    }]);*/
